import { commonUtils } from '@/helpers/commonUtils'
import styles from './MemberRequestPageMobile.module.less'
import { useRequest } from 'alova/client'
import { api } from '@/api'
import { useNavigate, useSearchParams } from 'react-router-dom'
import DefaultAvatar from '@/components/DefaultAvatar/DefaultAvatar'
import AButton from '@/components/A/AButton/AButton'
import { useEffect, useState } from 'react'
import { PAGE_LINKS } from '@/router/pageConst'
import AIcon from '@/components/A/AIcon/AIcon'
import { Trans, useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'

function MemberRequestPageMobile() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const c = searchParams.get('c')
  const { loading, data } = useRequest(api.memberRequest.info(c!))
  const [mode, setMode] = useState<'not_processed' | 'approve' | 'deny' | 'no_seat'>()
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  useEffect(() => {
    if (data) {
      if (data.hasSeat) {
        if (data.hasProcessed) {
          setMode(data.isAgree ? 'approve' : 'deny')
        } else {
          setMode('not_processed')
        }
      } else {
        setMode('no_seat')
      }
    }
  }, [data])

  useEffect(() => {
    const dataEmpty = !loading && !data
    const noC = !c
    if (noC || dataEmpty) {
      navigate(PAGE_LINKS.index)
    }
  }, [loading, data])

  return (
    data && (
      <div className={styles.memberRequestPage} data-testid='member-request-page'>
        <div className={styles.memberRequestPageContent}>
          <img className={styles.bg} src={commonUtils.getImagePath('pricingPageMobile/pricing-page-bg.png')} alt="" />
          <div className={styles.cardBox}>
            <img
              className={styles.logo}
              src={commonUtils.getImagePath('homePage/adeff-logo.png')}
              alt=''
            />
            {mode === 'not_processed' && (
              <>
                <p className={styles.title}>{t('memberRequestPage.title')}</p>
                <p className={styles.subTitle}>{t('memberRequestPage.subTitle')}</p>
                <div className={styles.account}>
                  <DefaultAvatar className={styles.accountAvatar} name={data.name} avatar={data.avatar} />
                  <div>
                    <p className={styles.username}>{data.name}</p>
                    <p className={styles.email}>{data.email}</p>
                  </div>
                </div>
                <AButton
                  testId='member-request-approve-btn'
                  // style={{ marginTop: 32 }}
                  className={styles.btn}
                  type='primary'
                  size='LGR'
                  loading={btnLoading}
                  onClick={() => {
                    setBtnLoading(true)
                    api.memberRequest
                      .deal({ c: c!, isAgree: true })
                      .send()
                      .then(() => {
                        setMode('approve')
                        setBtnLoading(false)
                      })
                      .catch(() => {
                        setBtnLoading(false)
                      })
                  }}
                >
                  {t('memberRequestPage.approve')}
                </AButton>
                <AButton
                  testId='member-request-deny-btn'
                  // style={{ marginTop: 24 }}
                  className={styles.btn}
                  type='outlined'
                  size='LGR'
                  loading={btnLoading}
                  onClick={() => {
                    setBtnLoading(true)
                    api.memberRequest
                      .deal({ c: c!, isAgree: false })
                      .send()
                      .then(() => {
                        setMode('deny')
                        setBtnLoading(false)
                      })
                      .catch(() => {
                        setBtnLoading(false)
                      })
                  }}
                >
                  {t('memberRequestPage.deny')}
                </AButton>
              </>
            )}
            {mode === 'no_seat' && (
              <>
                <img
                  className={styles.donePic}
                  src={commonUtils.getImagePath('memberRequestPage/page-full-pic.png')}
                  alt=''
                />
                <p className={styles.title} style={{ textAlign: 'center', marginTop: 16 }}>
                  {t('memberRequestPage.teamFull')}
                </p>
                <p className={styles.desc}>{t('memberRequestPage.yourTeamIsFull')}</p>
                <AButton
                  testId='member-request-contact-us-btn'
                  type='outlined'
                  size='LGR'
                  // style={{ marginTop: 32 }}
                  className={styles.btn}
                  onClick={() => {
                    navigate(PAGE_LINKS.contact)
                  }}
                >
                  <span>{t('pageHeader.contactUs')}</span>
                  <AIcon type='icon-line-global_arrow' />
                </AButton>
              </>
            )}
            {mode !== 'not_processed' && mode !== 'no_seat' && (
              <>
                <img
                  className={styles.donePic}
                  src={commonUtils.getImagePath('memberRequestPage/page-done-pic.png')}
                  alt=''
                />
                {mode === 'approve' && (
                  <>
                    <p className={styles.title} style={{ textAlign: 'center', marginTop: 16 }}>
                      {t('memberRequestPage.requestApproved')}
                    </p>
                    <p className={styles.desc}>
                      <Trans
                        i18nKey='memberRequestPage.approvedDesc'
                        values={{ name: data.name }}
                        components={{ tmp: <span style={{ fontWeight: 'bold' }} /> }}
                      />
                    </p>
                  </>
                )}
                {mode === 'deny' && (
                  <>
                    <p className={styles.title} style={{ textAlign: 'center', marginTop: 16 }}>
                      {t('memberRequestPage.requestDeclined')}
                    </p>
                    <p className={styles.desc}>
                      <Trans
                        i18nKey='memberRequestPage.declinedDesc'
                        values={{ name: data.name }}
                        components={{ tmp: <span style={{ fontWeight: 'bold' }} /> }}
                      />
                    </p>
                  </>
                )}
                <AButton
                  testId='member-request-contact-us-btn'
                  type='outlined'
                  size='LGR'
                  // style={{ marginTop: 32 }}
                  className={styles.btn}
                  onClick={() => {
                    navigate(PAGE_LINKS.contact)
                  }}
                >
                  <span>{t('pageHeader.contactUs')}</span>
                  <AIcon type='icon-line-global_arrow' />
                </AButton>
              </>
            )}
          </div>
        </div>
      </div>
    )
  )
}

export default observer(MemberRequestPageMobile)
